import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class AdminChatSidebar extends Component {
    constructor(props){
        super(props);
        
        this.state = {
            searchUsers: ''
        }
    }
    render(){
        return (
            <div className="chat-left">
                <div className="z-top">
                    <div role="tabpanel" className="tab-pane active no-padding" id="TabCourses">
                        <div className="search-chat form-control-with-icon">
                            <i className="zmdi zmdi-search"></i>
                            <input 
                                    type="text" 
                                    className="form-control search_chat" 
                                    placeholder="Search Courses"
                                    value={this.state.searchUsers || ''} 
                                    onChange={e => this.setState({searchUsers: e.target.value})}    
                                    
                                    />
                        </div>
                        <div className="chat-left-heading">
                            <p>Tickets By Courses</p>
                        </div>
                        <div className="chat-subjects-list no-border">
                            {this.state.searchUsers !== "" ?
                                <ul>
                                    {this.props.courses &&
                                        this.props.courses.filter(c => c.name.toLowerCase().indexOf(this.state.searchUsers.toLowerCase()) > -1).map((c, i) => {
                                            return (
                                                <li>
                                                    {this.props.view.params.view ?
                                                    <h4><Link to={`/chat/admin/${this.props.view.params.view}/${c.id}`}><span className="chat-subject-icon bg-announcements">{c.name[0]}</span> {c.name}</Link></h4>
                                                
                                                    : 
                                                    <h4><Link to={`/chat/admin/tickets/${c.id}`}><span className="chat-subject-icon bg-announcements">{c.name[0]}</span> {c.name}</Link></h4>
                                                
                                                    }
                                                    </li>
                                            )
                                        })
                                    }
                                </ul>
                            :
                                <ul>
                                    {this.props.courses &&
                                        this.props.courses.map((c, i) => {
                                            return (
                                                <li>
                                                    {this.props.view.params.view ?
                                                    <h4><Link to={`/chat/admin/${this.props.view.params.view}/${c.id}`}><span className={`chat-subject-icon subject-panel-bg-${i}`}>{c.name[0]}</span> {c.name}</Link></h4>
                                               
                                                    :
                                                    <h4><Link to={`/chat/admin/tickets/${c.id}`}><span className={`chat-subject-icon subject-panel-bg-${i}`}>{c.name[0]}</span> {c.name}</Link></h4>
                                               
                                                    }
                                                     </li>
                                            )
                                        })
                                    }
                                </ul>
                            }
                        </div>
                    </div>

                </div>

                <div className="mycs">
                    <div className="myc myc1"></div>
                    <div className="myc myc2"></div>
                    <div className="myc myc3"></div>
                </div>

            </div>
        )
    }
}

export default AdminChatSidebar;


// WEBPACK FOOTER //
// ./src/components/Chat/AdminChatSidebar.js